import { Button, Flex, Modal } from "antd";

import React from "react";
import Title from "antd/es/typography/Title";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { CustomTitle } from "../../../../../common/customTitle";
import { baseRouteMaker, routes } from "../../../../../../constants/routeConsts";
import { useTranslation } from "react-i18next";

const PurchaseGiftCardDialog = ({ open, onClose }) => {

  const {t} = useTranslation();

  /* For navigating between pages */
  const navigate = useNavigate();
  /* For navigating between pages */

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /* loading dependencies */
  const [loading, setLoading] = useState(false)
  /* loading dependencies */

  /* id dependencies */
  const { confirmPurchaseGiftCardDetails } = useSelector((state) => state.walletInfo);
  /* id dependencies */


  /* perform delete action */
  const handlePurchaseGiftCard = () => {
    if (
        confirmPurchaseGiftCardDetails &&
        confirmPurchaseGiftCardDetails !== "" &&
        confirmPurchaseGiftCardDetails !== null &&
        confirmPurchaseGiftCardDetails !== undefined && Object.keys(confirmPurchaseGiftCardDetails)?.length !== 0
    ) {
      navigate(baseRouteMaker(routes.GIFT_CARD_PAYMENT))
    }
    else {
      onClose()
    }
  };
  /* perform delete action */

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={false}
      confirmLoading={loading}
    >
      <Flex vertical gap="3rem" align="center" justify="center">
      <CustomTitle textDecoration="underline" justifyContent="center">
        {t("confirmationPopup.purchaseGiftCard")}
      </CustomTitle>
      <Title level={2}>{t("confirmationPopup.confirmPurchase")}</Title>
      <Flex gap="1rem" align="center" justify="center">
      <Button type="primary" onClick={handlePurchaseGiftCard}>{t("confirmationPopup.buttonYesText")}</Button>
      <Button type="default" onClick={onClose}>{t("confirmationPopup.buttonNoText")}</Button>
      </Flex>
      </Flex>
    </Modal>
  );
};

export default PurchaseGiftCardDialog;
